import React from "react";
// import React, { useContext } from "react";
import { IoIosArrowDroprightCircle } from "react-icons/io";
import ProfileCard from "../ProfileCard";
// import { UserContext } from "../../../../../../../UserContext.js";

const CurrentStateCard = ({ formData, onContinue }) => {
    // const { user } = useContext(UserContext);
  
    // const userName =
    // user?.firstName && user?.lastName
    //   ? `${user.firstName} ${user.lastName}`
    //   : user?.firstName || user?.lastName || "";
  return (
    <div className="h-full flex items-center justify-center p-8 scrollbar-hide">
      <div className=" absolute right-0 top-0 bottom-0 w-px bg-gray-300"></div>
      <div className="max-w-2xl w-full mt-4 py-8">
        <h1 className="text-3xl md:text-4xl font-bold text-center text-[#323232] font-gotham mb-4">
          This is who {formData.userName.split(' ')[0]} is today.
        </h1>

       <div className="max-w-[429px] mx-auto animate-scale-in relative">
          <ProfileCard formData={formData} editableName={false} headerLabel="Current State" />
          <div className="absolute bottom-[50%] right-0 translate-x-[100%] w-[95%] h-[5px] bg-[#E0E0E0]"></div>
        </div>

        <div className="text-center mt-8">
          <button
            onClick={onContinue}
            className="w-full max-w-[429px] px-4 py-4 bg-[#54B0AF] flex justify-between text-white rounded-[20px] font-gotham font-medium text-lg hover:bg-teal-600 transition-all shadow-lg hover:shadow-xl transform hover:scale-105 items-center gap-3 mx-auto"
          >
            Next: Build Your Future ID
            <IoIosArrowDroprightCircle className="w-5 h-5 md:w-7 md:h-7 text-lg" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CurrentStateCard;